import React, {useEffect, useState} from "react";
//images
import ad from "./assets/ad.png";
import Contacts from "./components/contacts";
//components
import Header from "./components/header/index";
import SideBar from "./components/sidebar";
import { Container } from "./styles";
//context
import { useUser } from "../context/allusers";

const preventf5 = false;

const Home = React.forwardRef((props, ref) => {
    const { language } = useUser();

    const preventf5 = (e) => {
        if (e.keyCode == 116) {
            e.preventDefault();
            alert("It is not possible to update this page from the keyboard.");
        }
    };

    useEffect(() => {
        if (!preventf5) window.addEventListener("keydown", (e) => preventf5(e));
    }, []);

    const [price, setPrice] = useState(null);

    useEffect(() => {
        const fetchPrice = async () => {
            try {
                const res = await fetch("https://api.dexscreener.com/latest/dex/pairs/solana/5R5cK7Q87r2TaCzfgzi5jvLK6J5W57sYuJzWLUoLpump");
                const data = await res.json();
                const priceUsd = data.pair?.priceUsd;
                if (priceUsd) setPrice(Number(priceUsd).toFixed(6));
            } catch (err) {
                console.error("Error fetching price:", err);
            }
        };

        fetchPrice();

        const interval = setInterval(fetchPrice, 10000); // refresh every 10s
        return () => clearInterval(interval);
    }, []);

    return (
        <Container>
            <div>
                <Header/>
            </div>
            <div id="contacts-div">
                <SideBar/>
                <Contacts/>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    margin: "20px 0 0 0",
                }}
            >
                <p>Current <b>$MSN</b> price: <big>{price ? `$${price}` : "Loading..."}</big></p>
            </div>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                }}
            >
                <p
                    style={{
                        color: "gray",
                        fontSize: "10px",
                    }}
                >
                    *Price provided by the DexScreener API — it may not be accurate at this time.</p>
            </div>

            <div id="ad-div">
                <img src={ad} alt=""/>
            </div>
        </Container>
);
});

export default Home;
